const alphabeticalOrder = new Intl.Collator('pt-BR');

export const compareLabelsByLength = (first, second) => {
  const firstTitle = String(first.title || '').normalize('NFC');
  const secondTitle = String(second.title || '').normalize('NFC');
  return (
    Array.from(firstTitle).length - Array.from(secondTitle).length ||
    alphabeticalOrder.compare(firstTitle, secondTitle)
  );
};
